import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/email', {
          params: payload,
        })
        .then((response) => {
          commit('SET_EMAIL_SMTP', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          console.log('errors ' + error)
          reject(error)
        })
    })
  },
  fetchRecord(context, host) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/email/${host}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/email', item)
        .then((response) => {
          commit('ADD_EMAIL_SMTP', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/email/' + item.id, item)
        .then((response) => {
          commit('UPDATE_EMAIL_SMTP', response.data)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  removeRecord({ commit }, host) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/email/${host}`)
        .then((response) => {
          commit('DELETE_EMAIL_SMTP', host)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
